<template>
  <svg
    v-bind="options.shape.svgAttrs"
    focusable="false"
    xmlns="http://www.w3.org/2000/svg">
    <symbol id="bounty-icon-symbol" :viewBox="options.shape.svgAttrs.viewBox">
        <component v-for="el in elements" :is="el.tag" v-bind="el" :key="el.d" />
    </symbol>
  </svg>
</template>

<script>
import { createCycler } from '@/color-cycler/cycler'

export default {
    name: 'ColorCycler',
    inheritAttrs: false,
    props: {
        options: {
            type: Object,
            default: () => {}
        },
        lastAnimationDate: Date,
    },
    watch: {
        lastAnimationDate: 'playAnimation'
    },
    computed: {
        elements: vm => vm.options.shape.elements
    },
    methods: {
        async playAnimation () {
            if (this.cycler?.running) {
                if (this.options.interruptible) {
                    this.cycler?.stop()
                } else {
                    return
                }
            }

            this.cycler = createCycler(this.elements, this.options)
            await this.cycler.cycle()
        }
    }
}
</script>

<style scoped>
path {
    transition: 100ms;
}
</style>
